import React from "react";
import { Button, Modal, Spinner } from "react-bootstrap";

const InfoModal = ({ show, handleClose, title, children, loading = false }) => {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <Spinner
            className={"d-block mx-auto"}
            animation="border"
            variant="primary"
          />
        ) : (
          <>{children}</>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Schließen
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InfoModal;
